import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';

const ResetButton = ({ onClick }) => {
    return (
        <button onClick={onClick} className="btn btn-secondary waves-effect waves-light clickable ml-3" type="reset">
            <FormattedMessage
                id="form.reset.button"
                defaultMessage="Cancel"
            />
        </button>
    )
}

export default injectIntl(ResetButton);


// WEBPACK FOOTER //
// ./web/src/components/common/ResetButton.jsx